import { z } from 'zod';
import type { MapData } from './types';

const nodeSchema = z.object({
  id: z.string().min(1),
  t: z.string(),
  curto: z.string().optional(),
  s: z.string().optional(),
  v: z.string().optional(),
  tipo: z.enum(['fundo', 'subclasse', 'spe', 'ativo', 'divida', 'cotistas']),
  nivel: z.number().optional(),
  pl: z.number().optional(),
  adm: z.string().optional(),
  fonte: z.string().optional(),
  cat: z.string().optional(),
  notas: z.array(z.number()).optional(),
  ficha: z.array(z.tuple([z.string(), z.string()])).optional(),
  itens: z.array(z.tuple([z.string(), z.string(), z.number()])).optional(),
}).loose();

const edgeSchema = z.object({
  de: z.string(),
  para: z.string(),
  tipo: z.enum(['participacao', 'composicao', 'cotistas', 'divida']),
  valor: z.number().optional(),
  pct: z.string().optional(),
  pctInv: z.string().optional(),
  instr: z.string().optional(),
  qtd: z.string().optional(),
  nota: z.number().optional(),
}).loose();

export const mapDataSchema = z.object({
  dataBase: z.string().optional(),
  nos: z.array(nodeSchema),
  arestas: z.array(edgeSchema),
  notas: z.array(z.tuple([z.number(), z.string(), z.string()])).optional(),
  categorias: z.array(z.tuple([z.string(), z.string()])).optional(),
  linhasExposicao: z.array(z.string()).optional(),
}).loose();

/** Tamanho máximo do JSON do mapa aceito na importação. */
export const MAP_MAX_BYTES = 2_000_000;

/**
 * Extrai os dados de um arquivo JSON ou do HTML do mapa
 * (bloco `<script id="dados" type="application/json">`).
 */
export function extractMapData(text: string): MapData {
  const t = text.trim();
  let raw: unknown;
  if (t.startsWith('{')) raw = JSON.parse(t);
  else {
    const re = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
    let m: RegExpExecArray | null, found: string | null = null;
    while ((m = re.exec(t))) {
      const attrs = m[1];
      if (/type\s*=\s*["'][^"']*json/i.test(attrs) || /id\s*=\s*["']dados["']/i.test(attrs) && /json/i.test(attrs)) { found = m[2]; break; }
    }
    if (!found) throw new Error('Não encontrei os dados do mapa nesse arquivo.');
    raw = JSON.parse(found);
  }
  const r = mapDataSchema.safeParse(raw);
  if (!r.success) throw new Error('O arquivo não está no formato do mapa societário.');
  return r.data as MapData;
}
